import {profCourse} from 'constants/url';
import {AddWith2ParamsOptions} from '../../../../components/grid-dx/types';
import {useAddWith2ParamsOptions} from './index';

function useAddProfilesSpacWithValidCourse() {
  const addCollaboratorInAttended = useAddWith2ParamsOptions(
    profCourse,
    'edit',
  ); // Cambiar URL
  return (addWith2ParamsOptions: AddWith2ParamsOptions) =>
    addCollaboratorInAttended(addWith2ParamsOptions);
}

export default useAddProfilesSpacWithValidCourse;
